import { parseDocumentBlocks } from './parseDocumentBlocks';

/**
 * Removes fenced (triple backtick) and inline (single backtick) code spans
 * from markdown content, leaving only the text that would actually be
 * rendered outside of a code block.
 */
export function stripCodeSpans(content: string): string {
  return parseDocumentBlocks(content)
    .filter(block => block.kind !== 'fence')
    .map(block => stripInlineCodeSpans(block.body))
    .join('\n');
}

function stripInlineCodeSpans(text: string): string {
  let out = '';
  let i = 0;
  while (i < text.length) {
    if (text[i] === '`') {
      let j = i + 1;
      while (j < text.length && text[j] !== '`' && text[j] !== '\n') {
        j++;
      }
      if (j < text.length && text[j] === '`') {
        i = j + 1;
        continue;
      }
    }
    out += text[i];
    i++;
  }
  return out;
}

/**
 * Filters out tokens (eg mentions, URLs) that only appear inside a single or
 * triple backtick code span, since those should be rendered as plain text
 * rather than getting mention/link/preview treatment.
 */
export function filterTokensOutsideCode<T extends { value: string }>(
  content: string,
  tokens: ReadonlyArray<T | null | undefined>,
): T[] {
  const visibleContent = stripCodeSpans(content);
  return tokens.filter((token): token is T => !!token && visibleContent.includes(token.value));
}
